/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Labs_Go_SettingsInputs */

const en_ui_labs_go_settings = /** @type {(inputs: Ui_Labs_Go_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Settings`)
};

const de_ui_labs_go_settings = /** @type {(inputs: Ui_Labs_Go_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu den Einstellungen`)
};

/**
* | output |
* | --- |
* | "Go to Settings" |
*
* @param {Ui_Labs_Go_SettingsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_labs_go_settings = /** @type {((inputs?: Ui_Labs_Go_SettingsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Labs_Go_SettingsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_labs_go_settings(inputs)
	return de_ui_labs_go_settings(inputs)
});